import locales from "@/consts/locales"
import { getCookie } from "@/utils/cookies"

export default () => {
  const defaultLanguage = getCookie("language")
  const currentLocale =
    (locales.some((item) => item.value === defaultLanguage) && defaultLanguage) ||
    process.env.VUE_APP_I18N_LOCALE ||
    "ru"

  return currentLocale
}
